import { Injectable } from '@angular/core';
import { AlloxApiService } from './allox-api.service';
import { EmergencyStop } from '../models';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class EmergencyStopService {

  private path = '/emergency';

  constructor(private http: AlloxApiService) { }

  public search() {
    const url = this.path;
    return this.http.get<[]>(url).pipe(
      map(objs => objs.map(obj => new EmergencyStop(obj)))
    );
  }

  public put(item: EmergencyStop) {
    const json = item.toJSON();
    return this.http.put(this.path, json);
  }
}
